import { useOrganizationSettings } from '../../settings/useOrganizationSettings/useOrganizationSettings';
import { defaultOrganizationBlobSettings } from '../constants/constants';
import useOrganizationSettingsGlobalUpdate from '../useOrganizationSettingsGlobalUpdate/useOrganizationSettingsGlobalUpdate';
import useSettingsUpdate from '../useSettingsUpdate/useSettingsUpdate';

const defaultSettings = defaultOrganizationBlobSettings.global.payroll;

export default function useOrganizationSettingsGlobalPayrollUpdate() {
  const settings = useOrganizationSettings()?.global?.payroll ?? defaultSettings;
  const updateSettings = useOrganizationSettingsGlobalUpdate();
  return useSettingsUpdate(settings, updateSettings, 'payroll');
}
